module.exports = __webpack_public_path__ + "media/bootstrap-icons/camera-1848ff4a.svg";